/** @format */
import React from "react";
import { StrKey } from "stellar-sdk";

import TextPicker from "./TextPicker";
import { ImportMark } from "../ImportMark";
import {
  useFreighter,
  freighterGetPublicKey,
} from "../../helpers/useFreighter";

export default function PubKeyPicker({
  placeholder,
  value,
  onUpdate,
  ...props
}) {
  const hasFreighter = useFreighter();

  return (
    <div className="PubKeyPicker">
      <TextPicker
        {...props}
        value={value}
        onUpdate={onUpdate}
        placeholder={
          placeholder ||
          ""
        }
        validator={(value) => {
          /* if (value.startsWith("M")) {
            if (value.length !== 69) {
              return "Muxed account address is invalid.";
            }
          } else if (!StrKey.isValidEd25519PublicKey(value)) {
            return "Public key is invalid.";
          } */
        }}
      />
      {hasFreighter && (
        <button
          type="button"
          onClick={() => freighterGetPublicKey(onUpdate)}
          className="s-button__icon PubKeyPicker__activator"
        >
          <ImportMark width={24} />
        </button>
      )}
    </div>
  );
}
